export const TABLET_DRAWER_WIDTH_COLLAPSED = 72;
export const TABLET_DRAWER_WIDTH_EXPANDED = 248;
export const MOBILE_FOOTER_HEIGHT = 70;
export const DESKTOP_HEADER_HEIGHT = 96;
export const TABLET_HEADER_HEIGHT = 64;
export const MOBILE_HEADER_HEIGHT = 70;
export const DESKTOP_DRAWER_WIDTH = 288;
export const TABLET_DRAWER_WIDTH = 96;
export const MOBILE_FOOTER_SPACE = 86;
